import { render, staticRenderFns } from "./TimelinePrimaryCard.vue?vue&type=template&id=bd36eace&"
import script from "./TimelinePrimaryCard.vue?vue&type=script&lang=js&"
export * from "./TimelinePrimaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports